import script from "./BarcodeKeyValueInfoMixin.vue?vue&type=script&lang=ts"
export * from "./BarcodeKeyValueInfoMixin.vue?vue&type=script&lang=ts"

export default script